import React from 'react';
import { OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import { RoundedWrapperStyled } from './styles';

interface RoundedWrapperProps {
  children: React.ReactNode;
  loading?: boolean;
  minHeight?: string;
  className?: string;
}

/*
 * A styled container component with a white rounded background.
 */
const RoundedWrapper: React.FC<RoundedWrapperProps> = ({ children, loading, className, minHeight = '' }) => {
  return (
    <RoundedWrapperStyled $minHeight={minHeight} className={className}>
      {loading ? <OverlaySpinner display overlay="none" /> : <>{children}</>}
    </RoundedWrapperStyled>
  );
};

export default RoundedWrapper;
